"use strict";
/**
 * @author Maxim Seredkin
 */
import angular from "angular";

export default [
  "$scope",
  "$routeParams",
  "$window",
  "$uibModalInstance",
  "$uibModal",
  "factFundByYear",
  "edit",
  function (
    $scope,
    $routeParams,
    $window,
    $modalInstance,
    $modal,
    factFundByYear,
    edit
  ) {
    $scope.ok = ok;
    $scope.cancel = cancel;
    $scope.edit = edit;

    $scope.factFundByYear = angular.copy(factFundByYear);
    $scope.factFundByYear.amount = 0;

    function ok() {
      $modalInstance.close($scope.factFundByYear);
    }

    function cancel() {
      $modalInstance.dismiss();
    }
  },
];
